module.exports = __webpack_public_path__ + "static/media/goods8_1.8aa8844e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods8_1.png
// module id = 1239
// module chunks = 0